import Skeleton from 'react-loading-skeleton';
import styles from './TextInfo.module.scss';

export interface TextInfoProps {
  label: string;
  value?: string;
}

export default function TextInfo({ label, value }: TextInfoProps) {
  const isLoading = value === undefined;

  return (
    <div className={styles.container}>
      <div className={styles.label}>
        {isLoading ? <Skeleton width="50px" height="16px" /> : label}
      </div>
      <div className={styles.value}>
        {isLoading ? <Skeleton width="120px" height="20px" /> : value}
      </div>
    </div>
  );
}
